import React, { useEffect } from 'react';
import EditControlButton from '../../../../../common/Button/EditControlButton/EditControlButton';
import { useDispatch, useSelector } from 'react-redux';
import {
    multiPolygonEditedIDState,
    isPolygonDragActiveState,
    isShowPolygonBreakpointsState,
    isUsingMeasuringToolState,
    mapOptionsState,
    mapTileUrlState,
    isShowDetailsButtonState,
    isEarthEngineServiceActiveState,
} from '../../../../../../app/redux/retrievers/retrievers';
import { setIsShowPolygonBreakpoints } from '../../../../../../app/redux/slices/isShowPolygonBreakpointsSlice';
import { setIsPolygonDragActive } from '../../../../../../app/redux/slices/isPolygonDragActive';
import { setIsUsingMeasuringTool } from '../../../../../../app/redux/slices/isUsingMeasuringToolSlice';
import { setIsEarthEngineServiceActiveState } from '../../../../../../app/redux/slices/isEarthEngineServiceActiveSlice';
import { EditControlCustomButtonsStyles } from './styles/EditControlCustomButtons.styles';
import MapCoordinatesToggleMenu from './EditControlButtonMenus/MapCoordinatesToggleMenu/MapCoordinatesToggleMenu';
import MeasureToolMenu from './EditControlButtonMenus/MeasureToolMenu/MeasureToolMenu';
import MapDetailsBody from '../../../../../common/MapDetailsBody/MapDetailsBody';

import './styles/edit.control.cust.btns.styles.css';
import EarthEngineService from '../../../../components/EarthEngineService/EarthEngineService';

const EditControlCustomButtons = () => {
    const dispatch = useDispatch();
    const isShowPolygonBreakpoints = useSelector(isShowPolygonBreakpointsState);
    const isPolygonDragActive = useSelector(isPolygonDragActiveState);
    const isShowDetailsButton = useSelector(isShowDetailsButtonState);
    const isEarthEngineServiceActive = useSelector(isEarthEngineServiceActiveState);
    const multiPolygonEditedIdState = useSelector(multiPolygonEditedIDState);
    const isUsingMeasuringTool = useSelector(isUsingMeasuringToolState);
    const mapTileUrl = useSelector(mapTileUrlState);
    const mapOptions = useSelector(mapOptionsState);

    useEffect(() => {
        if (isPolygonDragActive) {
            dispatch(setIsPolygonDragActive(false));
        }
    }, [mapTileUrl]);

    return (
        <div className="edit-control-cust-btns-holder" style={EditControlCustomButtonsStyles.Holder}>
            {/*polygon breakpoints button*/}
            {mapOptions && mapOptions.tools.breakpoints && (
                <EditControlButton
                    id="breakpointsBtn"
                    tooltipTxt="مشاهدۀ نقاط"
                    state={isShowPolygonBreakpoints}
                    setState={setIsShowPolygonBreakpoints}
                    // ternaryText={`${isShowPolygonBreakpoints ? '-' : '+'}`}
                    icon="/images/icons/breakpoints.png"
                />
            )}
            {/*polygon drag*/}
            {mapOptions && mapOptions.tools.dragControl && multiPolygonEditedIdState === 0 && (
                <EditControlButton
                    id="polygonDragBtn"
                    tooltipTxt="درگ پالیگان"
                    state={isPolygonDragActive}
                    setState={setIsPolygonDragActive}
                    dependenceState={isUsingMeasuringTool}
                    icon="/images/icons/drag.png"
                    isDisabled={isEarthEngineServiceActive}
                />
            )}
            {/*measuring tool*/}
            <EditControlButton
                id="measuringToolBtn"
                tooltipTxt="ابزار اندازه گیری"
                state={isUsingMeasuringTool}
                setState={setIsUsingMeasuringTool}
                dependenceState={isPolygonDragActive}
                MenuComponent={MeasureToolMenu}
                icon="/images/icons/ruler.png"
            />
            {/*coordinates type toggler*/}
            <EditControlButton
                id="currentCoordsToggleBtn"
                tooltipTxt="تنظیمات مختصات"
                MenuComponent={MapCoordinatesToggleMenu}
                icon="/images/icons/globe.png"
            />
            {/*show Details List*/}
            {isShowDetailsButton && (
                <EditControlButton
                    id="mapReportDetailsBtn"
                    tooltipTxt="جزئیات"
                    MenuComponent={MapDetailsBody}
                    icon="/images/icons/details.png"
                />
            )}
            {/*earth engine service activation*/}
            {/* <EditControlButton
                id="earthEngineServiceBtn"
                tooltipTxt="سرویس داده زمین"
                state={isEarthEngineServiceActive}
                setState={setIsEarthEngineServiceActiveState}
                // dependenceState={isEarthEngineServiceActive}
                MenuComponent={EarthEngineService}
                backgroundSize="22px"
                // hasExternalCloseButton={true}
                icon="/images/icons/satellite.png"
            /> */}
        </div>
    );
};

export default EditControlCustomButtons;
